const initCustomSliders = () => {
  const sliderWrappers = document.querySelectorAll('[data-it-slider]');

  sliderWrappers.forEach((sliderWrap) => {
    const container = sliderWrap.querySelector('.it-slider-container');
    const slides = sliderWrap.querySelectorAll('.it-slide');
    const arrow = sliderWrap.querySelector('[data-next-arrow]');
    const animType = sliderWrap.getAttribute('data-anim-type');
    const autoplayEnabled = sliderWrap.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(sliderWrap.getAttribute('data-autoplay-speed')) * 1000; // Use the value from the schema
    const totalSlides = slides.length;
    let currentIndex = 0;
    let autoplayInterval = null;

    function updateSlider(index) {
      // Pause autoplay during manual interaction
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
      }

      // Handle Transitions
      if (animType === 'slide') {
        container.style.transform = `translateX(-${index * 100}%)`;
      } else {
        slides.forEach(s => s.classList.remove('active-slide'));
        slides[index].classList.add('active-slide');
      }
      
      // Sync all dots in all slides within THIS specific slider
      const allDots = sliderWrap.querySelectorAll('.it-dot');
      allDots.forEach((dot) => {
        dot.classList.toggle('active', parseInt(dot.dataset.index) === index);
      });
      
      currentIndex = index;

      // Restart autoplay after brief pause (to avoid overlap with manual interaction)
      if (autoplayEnabled) {
        setTimeout(() => startAutoplay(), autoplaySpeed); // Start after delay equal to autoplay speed
      }
    }

    function startAutoplay() {
      if (autoplayEnabled && totalSlides > 1) {
        autoplayInterval = setInterval(() => {
          currentIndex = (currentIndex + 1) % totalSlides;
          updateSlider(currentIndex);
        }, autoplaySpeed); // Use autoplay speed from schema
      }
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Navigation arrow
    if (arrow) {
      arrow.addEventListener('click', () => {
        stopAutoplay();
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider(currentIndex);
      });
    }

    // Dot navigation
    sliderWrap.addEventListener('click', (e) => {
      if (e.target.classList.contains('it-dot')) {
        stopAutoplay();
        updateSlider(parseInt(e.target.dataset.index));
      }
    });

    // Pause on hover
    sliderWrap.addEventListener('mouseenter', stopAutoplay);
    sliderWrap.addEventListener('mouseleave', () => {
      if (autoplayEnabled) startAutoplay();
    });

    // Initialize autoplay
    if (autoplayEnabled) {
      setTimeout(startAutoplay, autoplaySpeed); // Start autoplay with the schema speed
    }
  });
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', initCustomSliders);

// Important for Shopify: Re-run when the theme editor section is saved/reloaded
document.addEventListener('shopify:section:load', initCustomSliders);